// src/features/websites/components/HeadlessConfigFields.tsx
import React from 'react';
import {
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';

interface HeadlessConfigFieldsProps {
  username: string;
  password: string;
  isLoading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const HeadlessConfigFields: React.FC<HeadlessConfigFieldsProps> = ({
  username,
  password,
  isLoading,
  onChange,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Interactive Website Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        If the website requires authentication to access content, you can provide credentials below.
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Username (Optional)"
            name="headlessAuth.username"
            value={username || ''}
            onChange={onChange}
            disabled={isLoading}
            placeholder="Enter username if required"
          />
        </Grid>
        
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Password (Optional)"
            name="headlessAuth.password"
            type="password"
            value={password || ''}
            onChange={onChange}
            disabled={isLoading}
            placeholder="Enter password if required"
          />
        </Grid>
      </Grid>
    </Paper>
  );
};